import { render, staticRenderFns } from "./AlertCount.vue?vue&type=template&id=64b81f22"
import script from "./AlertCount.vue?vue&type=script&lang=ts"
export * from "./AlertCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports